// extracted by mini-css-extract-plugin
module.exports = {"paper":"TodoList_paper__327Wa","header":"TodoList_header__oH_yv","text":"TodoList_text__21gwK","add":"TodoList_add__33KcB","button":"TodoList_button__3EDAD"};